var React = require('react');

function Telegram (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M20.014 0.118354L1.00217 7.44963C-0.295303 7.97076 -0.287797 8.69456 0.764124 9.01732L5.64521 10.54L16.9386 3.41459C17.4726 3.08968 17.9605 3.26447 17.5595 3.62047L8.40958 11.8782H8.40744L8.40958 11.8793L8.07288 16.9105C8.56614 16.9105 8.78381 16.6842 9.06046 16.4172L11.4313 14.1118L16.3628 17.7544C17.2721 18.2551 17.9251 17.9978 18.1514 16.9126L21.3886 1.65602C21.72 0.327452 20.8814 -0.274105 20.014 0.118354Z","fill":"#6E717F"}));
}

Telegram.defaultProps = {"width":"22","height":"18","viewBox":"0 0 22 18","fill":"none"};

module.exports = Telegram;

Telegram.default = Telegram;
